import api from "Helpers/Api";

export default async function bannerDelete(bannerId: string) {
  const { data } = await api.delete(`/banners/${bannerId}`);
  return data;
}
